import "../styles/main.css";

import { initSharedBehaviors } from "./_shared.js";

function init() {
  initSharedBehaviors();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
